
  import { Vue, Component, Prop } from "vue-property-decorator";
  import ApplicantChip from "@/components/recruitings/ApplicantChip.vue";
  import RouteNames from "@/entities/RouteNames";

  interface IApplicant {
    name: string;
    id: string;
    contractorId?: string;
  };

  @Component({
    components: {
      ApplicantChip,
    },
  })
  export default class ApplicantChips extends Vue {
    @Prop({required: true,  type: Array}) readonly applicants!: IApplicant[];
    @Prop({default: 3, type: Number}) readonly limit!: number;
    @Prop({required: true, type: String}) readonly postingId!: string;

    routes = RouteNames;

    get applicantsToRender(): IApplicant[] {
     return this.applicants.slice(0, this.limit);
    }

    get applicantsMoreThanLimit(): boolean {
      return this.applicants.length > this.limit;
    }
  }
